/**
 * Ginja /me/access permission key constants (server-defined strings).
 * Match API `permissions[].key` values exactly, including any typos.
 */
export const PERM = {
  // Sales — Leads
  GET_LEADS: "get_leads",
  // Sales — Auto / manual quote
  GET_AUTO_QUOTE: "get_auto_quote",
  GET_MANUAL_QUOTE: "get_manual_quote",
  /** API spelling */
  MANAUL_QUOTE: "manaul_quote",
  AUTO_QUOTE: "auto_quote",
  // Sales — other
  GET_POLICIES: "get_policies",
  GET_COMMISSIONS: "get_commissions",
  /** API spelling */
  GET_DEBT_MANAGMENT: "get_debt_managment",
  // IT — registry / access (example from access-control feature)
  ACCESS_CONTROL: "access_control",
};

/** Core quote & underwriting flows (Sales feature permissions). */
export const ANY_QUOTE_ACCESS = [
  PERM.GET_AUTO_QUOTE,
  PERM.GET_MANUAL_QUOTE,
  PERM.MANAUL_QUOTE,
  PERM.AUTO_QUOTE,
];

/** Broad set when a route should allow anyone with a sales quote *or* commission role. */
export const ANY_QUOTE_OR_COMMISSIONS = [...ANY_QUOTE_ACCESS, PERM.GET_COMMISSIONS];

export const anyQuoteKey = (keys) => {
  const anyQuote = new Set(ANY_QUOTE_OR_COMMISSIONS);
  if (!Array.isArray(keys)) return false;
  return keys.some((k) => anyQuote.has(k));
};
